import { DirectiveOptions } from "vue";
import { DirectiveBinding } from "vue/types/options";

function setPosition(element: HTMLElement, binding: DirectiveBinding) {
  let isLtr = true;

  element.style.position = "fixed";
  element.style.top = window.innerHeight  * 0.220 + "px";
  element.style.left = window.innerWidth  * 0.622 + "px";
  element.style.width = window.innerWidth * 0.090 + "px";
}

const booths: DirectiveOptions = {
  inserted(el, binding) {
    setPosition(el, binding);
  },
  update(el, binding) {
    setPosition(el, binding);
  }
};

export default booths;
